/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import config from '../../../config';
import FileSystemPathFactory from '../../file/system/file-system-path-factory';
import FileSystemType from '../../file/system/file-system-type';

/**
 * @private
 * @import { InternalBasePath } from '../../basepath/basepath'
 * @import { LogicalUnitMapper } from '../../logical-unit-mapper/'
 */

/**
 * Resolver pro interní cestu.
 * @implements {InternalBasePath}
 */
export default class WebInternalBasePath {
  /**
   * Vytvoří instanci.
   * @param {LogicalUnitMapper} logicalUnitMapper Mapovač logických jednotek
   */
  constructor(logicalUnitMapper) {
    this.logicalUnitMapper = logicalUnitMapper;
  }

  /** @type {InternalBasePath['resolve']} */
  async resolve(logicalUnit) {
    const fileSystemUnit = await this.logicalUnitMapper.toFileSystemUnit(
      logicalUnit
    );
    if (fileSystemUnit.getType() !== FileSystemType.Internal) {
      throw new Error('unit is not internal');
    }
    return FileSystemPathFactory.fromValue(
      `/${logicalUnit.getName()}/${config.name}/asset`
    );
  }
}
